function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* Finds the navigation items for the mobile modal buttons */
import React, { useCallback, useMemo } from 'react';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { FloorPlanIcon, ThreeDimensionalIcon, VideoIcon } from '@domain-group/fe-co-icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var useNavItems = _ref => {
  var items = _ref.items,
    updateSelectedIndex = _ref.updateSelectedIndex;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var handleNavigationClick = useCallback(_ref2 => {
    var item = _ref2.item,
      event = _ref2.event;
    sendEvent("navigation.".concat(event));
    updateSelectedIndex(item.id);
  }, [sendEvent, updateSelectedIndex]);
  var findItem = useCallback((type, Icon, event) => {
    var item = items.find(each => each.type === type);
    return item ? _objectSpread(_objectSpread({}, item), {}, {
      onClick: () => handleNavigationClick({
        item,
        event
      }),
      icon: ___EmotionJSX(Icon, null)
    }) : null;
  }, [items, handleNavigationClick]);
  var navItems = useMemo(() => [findItem('FLOORPLAN', FloorPlanIcon, 'floorplan-click'), findItem('VIDEO', VideoIcon, 'video-click'), findItem('VIRTUAL_TOUR', ThreeDimensionalIcon, 'virtualtour-click')].filter(each => each), [findItem]);
  return navItems;
};
export default useNavItems;